// extracted by mini-css-extract-plugin
module.exports = {"location":"LocationField_location__VuUmY","box":"LocationField_box__zzy5S","compact":"LocationField_compact__1tfOp","vertical":"LocationField_vertical__o5_CT"};